import React from 'react';
import { componentService } from 'js/services/component.service';

export const SelfExclusion = React.lazy(() => import(/* webpackChunkName: "self-exclusion" */ './SelfExclusion'));

componentService.registerPageComponents({ 'self-exclusion': SelfExclusion });
